import { TABLE_CELL_TYPE } from '../types/enums.ts';
import type React from 'react';

export const isPhoneNumberType = (type: TABLE_CELL_TYPE, originalType: string, columnId: string) => {
  return type === TABLE_CELL_TYPE.PHONE_NUMBER || originalType === 'PhoneNumber' || columnId?.includes('phone') || columnId?.includes('tel');
};

export const isEmailType = (type: TABLE_CELL_TYPE, originalType: string, columnId: string) => {
  return type === TABLE_CELL_TYPE.EMAIL || originalType === 'Email' || columnId?.includes('email');
};

export const stopPropagation = (e: React.MouseEvent<HTMLElement>) => {
  e.stopPropagation();
};
